// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__g20nl","insightsList":"newBusinessInsightsMenu_insightsList__1dIzN","active":"newBusinessInsightsMenu_active__Ev77i"};